import { PATHS } from "./routes";

const stripTrailingSlash = (value) =>
  typeof value === "string" ? value.trim().replace(/\/+$/, "") : "";

const buildAbsoluteUrl = (baseUrl, path) => {
  const base = stripTrailingSlash(baseUrl);
  if (!base) return path;

  try {
    return new URL(path, `${base}/`).toString();
  } catch {
    return `${base}${path}`;
  }
};

export const getAuthCallbackUrl = () => {
  const explicitRedirectUri = stripTrailingSlash(import.meta.env?.VITE_AUTH0_REDIRECT_URI);
  if (explicitRedirectUri) return explicitRedirectUri;

  const baseUrl =
    stripTrailingSlash(import.meta.env?.VITE_BASE_URL) ||
    (typeof window !== "undefined" ? stripTrailingSlash(window.location.origin) : "");

  return buildAbsoluteUrl(baseUrl, PATHS.authCallback);
};
